import type { CustomArticle } from '@hoopoe/shared';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { api } from '../api';
import { type Article, fromCustom } from './articles';

/** Admin-written articles the user may read (PLAN §12.6), shaped like built-in ones. */
export const customArticlesQuery = {
  queryKey: ['help', 'articles'],
  queryFn: () => api<{ articles: CustomArticle[] }>('/help/articles'),
  staleTime: 5 * 60_000,
};

const NONE: Article[] = [];

/** `pending` while the first load runs, so a custom article's page doesn't flash "not found". */
export function useCustomArticlesState(): { articles: Article[]; pending: boolean } {
  const { data, isPending } = useQuery(customArticlesQuery);
  const articles = useMemo(() => data?.articles.map(fromCustom) ?? NONE, [data]);
  return { articles, pending: isPending };
}

export const useCustomArticles = (): Article[] => useCustomArticlesState().articles;
